import React from 'react';
import momentJalaali from 'moment-jalaali';
import 'moment/locale/fa';

// Load Persian locale with custom settings
momentJalaali.loadPersian({ usePersianDigits: true, dialect: 'persian-modern' });
momentJalaali.locale('fa');
momentJalaali.updateLocale('fa', {
  relativeTime: {
    future: 'در %s',
    past: '%s پیش',
    s: 'چند ثانیه',
    ss: '%d ثانیه',
    m: 'یک دقیقه',
    mm: '%d دقیقه',
    h: 'یک ساعت',
    hh: '%d ساعت',
    d: 'یک روز',
    dd: '%d روز',
    M: 'یک ماه',
    MM: '%d ماه',
    y: 'یک سال',
    yy: '%d سال'
  }
});

interface Props {
  create_date: string;
}

const GetDate: React.FC<Props> = ({ create_date }) => {
  return (
    <div>
      {momentJalaali(create_date).fromNow()}
    </div>
  );
};

export default GetDate;
